import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Button } from '@che-ins-ui/button';
import { memo } from 'react';
import { CircleLoader } from '@/components/common/CircleLoader/CircleLoader';
import { useCheTheme } from '@/styles/themes';
import { formatPriceWithCurrency } from '@/libs/helpers/utils';
import { currentStepSelector, isLastStepSelector, } from '@/models/steps/selectors';
import { STEPS_WITH_PRICE } from '@/models/steps';
import { useInsurancePrice } from '../hooks/useInsurancePrice';
import { PaymentButtonTextSvg } from './PaymentButtonTextSvg';
export const ContinueButton = memo(({ isDisabled, isLoading, onClick }) => {
    const theme = useCheTheme();
    const currentStep = useSelector(currentStepSelector);
    const { price, isLoading: isPriceLoading } = useInsurancePrice();
    const isLastStep = useSelector(isLastStepSelector);
    const shouldShowPrice = STEPS_WITH_PRICE.includes(currentStep);
    const handlePointerDown = () => {
        if (document.activeElement instanceof HTMLInputElement ||
            document.activeElement instanceof HTMLTextAreaElement) {
            document.activeElement.blur();
        }
    };
    return (_jsx(Button, { shouldFitContent: true, onClick: isDisabled || isLoading ? undefined : onClick, onPointerDown: handlePointerDown, passAppearancesToComponent: false, appearance: "continue", baseAppearance: isLastStep ? 'success' : 'continue', disabled: isDisabled, "data-loading": isLoading, children: isLoading ? (_jsx(CircleLoader, { color: theme.colors.white })) : (_jsxs(_Fragment, { children: [isLastStep ? _jsx(PaymentButtonTextSvg, {}) : 'Продолжить', shouldShowPrice && (_jsxs(_Fragment, { children: ['\u00a0', _jsx("b", { children: isPriceLoading
                                ? '...'
                                : formatPriceWithCurrency(price, 'rub') })] }))] })) }));
});
